// extracted by mini-css-extract-plugin
export default {"modalCardBase":"Z5ClyzUKO0O0vgsRFIYi1","modalCardHidden":"_2E3qibtFzOzYCPjPD8PuPQ","modalCardButton":"_2AJEyvCI3ZepUcFESFZ5Zv","selected":"_2LrM7QrC73a8Q0l3juVXHf"};